import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';
import {
  LoginContainer,
  LoginCard,
  LoginButton,
  LoginTitle,
  LoginSubtitle
} from './styles';

const LoginPage = () => {
  const { login, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from;
      navigate(
        {
          pathname: from?.pathname || '/',
          search: from?.search || '',
        },
        { replace: true },
      );
    }
  }, [isAuthenticated, navigate, location]);

  const handleLogin = () => {
    login();
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    return null;
  }

  return (
    <LoginContainer>
      <LoginCard>
        <LoginTitle>Welcome to My Software Mind</LoginTitle>
        <LoginSubtitle>Sign in with your Microsoft account to continue</LoginSubtitle>
        <LoginButton onClick={handleLogin}>
          Sign in with Microsoft
        </LoginButton>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;
